export default {
  LIST (state, value) {
    if (value && Array.isArray(value)) {
      state.list = value.map((v) => {
        v.organizationId = v.organization.id
        v.organizationName = v.organization.name
        return v
      })
    } else {
      state.list = []
    }
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      value.organizationId = value.organization.id
      value.organizationName = value.organization.name
      state.list.push(value)
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      value.organizationId = value.organization.id
      value.organizationName = value.organization.name
      state.list.splice(index, 1, value)
    }
  },
  OVERDUE_LIST (state, value) {
    state.overdue_list = value
  },
  NOT_BACKEDUP_LIST (state, value) {
    state.not_backedup_list = value
  },
  SET_SYSTEM_COUNT (state, value) {
    state.count = value
  },
  HIGHLIGHT_CONTENT (state, value) {
    state.highlightContent = !!value
  },
  SET_SYSTEM_OK (state, value) {
    state.ok = value
  },
  CURRENT (state, value) {
    const current = {
      active: null,
      alarmed: false,
      alarms: [],
      allowUpgrade: false,
      gitTagVersion: '',
      approvedGitVersions: [],
      autoAssignName: false,
      backups: [],
      backupContent: '',
      backupsCount: 0,
      backupsSize: 0,
      backupMethod: '',
      branch: '',
      clientVersion: '',
      contractStatus: '',
      coreUpdates: false,
      filesets: [],
      forceDue: false,
      hasClient: false,
      id: '',
      internalIp: '',
      ip: '',
      keyConnected: false,
      kind: '',
      lastBackup: '',
      lastBackupLog: '',
      lastBackupStatus: '',
      lastConnection: '',
      lastLog: '',
      name: '',
      notes: '',
      organization: { id: '', name: '' },
      password: '',
      projectManager: '',
      reenableTime: null,
      retention: '',
      schedule: '',
      server: '',
      softwareRole: '',
      tempZipLocation: '',
      username: ''
    }
    const update = {
      active: null,
      allowUpgrade: false,
      gitTagVersion: '',
      autoAssignName: false,
      backupContent: '',
      branch: '',
      coreUpdates: false,
      forceDue: false,
      id: '',
      kind: '',
      name: '',
      notes: '',
      password: '',
      reenableTime: null,
      retention: '',
      schedule: '',
      server: '',
      tempZipLocation: '',
      username: ''
    }
    if (value) {
      for (const [key, entry] of Object.entries(value)) {
        if (current[key] !== undefined) {
          current[key] = entry
        }
        if (update[key] !== undefined) {
          update[key] = entry
        }
      }
    }
    state.current = current
    state.update = update
    state.current.organization = value?.organization || ''
    state.current.backups = value?.backups || []
    state.current.filesets = value?.filesets || []
  },
  S3_BACKUPS_LIST (state, value) {
    state.s3BackupsList = value
  },
  UPDATE (state, opts) {
    state.update[opts.name] = opts.value
  },
  UPDATE_APPROVED_CLIENT_VERSION (state, value) {
    state.update.gitTagVersion = value
  },
  UPDATE_AUTO_ASSIGN_NAME (state, value) {
    state.update.autoAssignName = value
  },
  UPDATE_BACKUP_CONTENT (state, value) {
    state.update.backupContent = value
  },
  UPDATE_NAME (state, value) {
    state.update.name = value
  },
  UPDATE_KIND (state, value) {
    state.update.kind = value
  },
  UPDATE_SCHEDULE (state, value) {
    state.update.schedule = value
  },
  UPDATE_BRANCH (state, value) {
    state.update.branch = value
  },
  UPDATE_RETENTION (state, value) {
    state.update.retention = value
  },
  UPDATE_SERVER (state, value) {
    state.update.server = value
  },
  UPDATE_USERNAME (state, value) {
    state.update.username = value
  },
  UPDATE_PASSWORD (state, value) {
    state.update.password = value
  },
  UPDATE_ALLOW_UPGRADE (state, value) {
    state.update.allowUpgrade = value
  },
  UPDATE_FORCE_DUE (state, value) {
    state.update.forceDue = value
  },
  UPDATE_NOTES (state, value) {
    state.update.notes = value
  },
  UPDATE_ACTIVE (state, value) {
    state.update.active = value
  },
  UPDATE_REENABLE_TIME (state, value) {
    state.update.reenableTime = value
  },
  UPDATE_CORE_UPDATES (state, value) {
    state.update.coreUpdates = value
  },
  PURGE_LIST (state, value) {
    state.current.purgeList = value.purgeList
    state.current.purgeSize = value.purgeSize
    state.current.keepSize = value.keepSize
  },
  ALARMS (state, value) {
    state.alarms = value
  },
  DISABLE_ALARM (state) {
    state.current.alarmed = false
  },
  UPDATE_BACKUP_METHOD (state) {
    let type = state.current.backupMethod
    if (type === 'none') {
      type = 'manual'
    } else if (type === 'auto') {
      type = 'mixed'
    }
  },
  UPDATE_TEMP_ZIP_LOCATION (state, value) {
    state.update.tempZipLocation = value
  },
  REMOVE_BACKUP (state, key) {
    const index = state.current.backups.findIndex(backup => backup.s3Key === key)
    if (index !== -1) {
      state.current.backups.splice(index, 1)
    }
  }
}
